

















import { Vue, Component, Mixins } from "vue-property-decorator";

import _ from "lodash";
import MyCommon from "@/mixins/common";
import SelectStadium from "@/components/selectstadium.vue";

import VChart, { THEME_KEY } from "vue-echarts";

@Component({
  components: {
    VChart,
    SelectStadium
  },
  provide: {
    [THEME_KEY]: "light"
  }
})
export default class extends Mixins(MyCommon) {
  option: any = {
    // title: {
    //   text: '用户注册增长曲线',
    //   subtext: ''
    // },
    grid: {
      // left: '3%',
      // right: '4%',
      // bottom: '3%',
      containLabel: true
    },
    legend: {
      data: ["用户数"]
    },
    tooltip: {
      trigger: "axis"
    },
    xAxis: {
      type: "category",
      data: []
    },
    yAxis: {
      type: "value"
    },
    series: [
      {
        data: [],
        name: "用户数",
        type: "bar"
      }
    ]
  };

  ei: any = {};

  async loadData(params?: any) {
    const res2 = await this.$store.dispatch("statistics/userTotal", params);
    if (res2 && res2.Data) {
      this.option.xAxis.data = [];
      this.option.series[0].data = [];
      for (const obj of res2.Data) {
        //   console.log(obj)
        this.option.xAxis.data.push(obj.d);
        this.option.series[0].data.push(obj.ccount);
      }
    }
  }

  mounted() {
    this.loadData();
  }

  changeDate(dates: any[], dateStrings: any[]) {
    this.loadData({
      start_time: `${dateStrings[0]} 00:00:00`,
      end_time: `${dateStrings[1]} 23:59:59`
    });
  }
}
